module.exports = {
	/**
	 * @type {string}
	 * @description 首页三张背景图
	 */
	bg1: '/img/bg1_v2.jpg',
	bg2: '/img/bg2_v2.jpg',
	bg3: '/img/bg3_v2.jpg',

	/**
	 * @type {string}
	 * @description 首页故障风文字
	 */
	malfunctionText: 'Wyver'
}
